module.exports = __webpack_public_path__ + "static/img/sina.ac873712.png";